var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import { useDebounce } from 'use-debounce';
import Sheet from 'sheet-happens';
import { FaPlus, FaTimes } from 'react-icons/fa';
import { CellStatus, TagType, WidgetType } from '@common/api';
import { useLanguage } from '@base/LanguageProvider';
import FSButton from '@components/FSButton';
import WidgetMenu from '@main/dashboard/WidgetMenu';
import WidgetLoader from '@main/dashboard/WidgetLoader';
import WidgetParentChangeModal from '@main/dashboard/WidgetParentChangeModal';
import Tag from '@shared/tags/Tag';
import Manager from '@shared/modal/Manager';
import { Copy, Delete, Edit, Labels, NumberIcon, Select, Sum } from '@shared/icons/icons';
import { LabelOptions, SubtotalsOptions } from '@data/types';
import { useTagContext } from '@data/tag/tagContext';
import { useAuth } from '../../../providers/AuthProvider';
import { parseWidgetConfig } from '@data/widgets/widgetConfig';
import { useCloneWidget, useDeleteWidget, useUpdateWidget } from '@data/widgets/widgetActions';
import { createDraggableId, createDroppableId, PivotZone, DraggableType, DroppableType, getDraggableTagType, } from '@data/dragAndDrop/types';
import { PivotAddButton, TagDropzone, TagDropzoneButton, TagDropzoneGrid, TagDropzonePlaceholder, WidgetBox, WidgetContent, WidgetTitle, } from '@styled/Widget';
import useTableCells from '@hooks/useTableCells';
import numbro from 'numbro';
import { cellsApi, evaluatorApi } from '@data/rest/api';
import { getTagDisplayName, getTagLongName } from '@data/tag/tagUtil';
import { evaluateTagProgram, Opcode, TagProgramBuilder } from '@data/tag/tagEvaluator';
import { dateToSerial, isExcelDateFormat, serialToDate } from '@util/number';
import { appColors } from '@styled/useTheme';
import { ThreeStateCheckBox } from '@shared/input/CheckBox';
import { NumberFormatType, numberFormatTypesMeta } from '@util/enums';
import { formatNumber } from '@util/formatNum';
import toast from 'react-hot-toast';
import { Loading, LoadingWrap } from '@styled/Basic';
var triangleRight = new Image();
triangleRight.src =
    'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiCgkgdmlld0JveD0iMCAwIDEwMCAxMDAiIG92ZXJmbG93PSJ2aXNpYmxlIiA+Cjxwb2x5Z29uIHBvaW50cz0iMCwwIDEwMCw1MCAwLDEwMCIgc3R5bGU9ImZpbGw6Izk5OTk5OTsiLz4KPC9zdmc+Cg==';
triangleRight.width = 10;
triangleRight.height = 10;
var triangleDown = new Image();
triangleDown.src =
    'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiDQoJIHZpZXdCb3g9IjAgMCAxMDAgMTAwIiBvdmVyZmxvdz0idmlzaWJsZSIgPg0KPHBvbHlnb24gcG9pbnRzPSIwLDAgMTAwLDAgNTAsMTAwIiBzdHlsZT0iZmlsbDojOTk5OTk5OyIvPg0KPC9zdmc+DQo=';
triangleDown.width = 10;
triangleDown.height = 10;
export default function Pivot(_a) {
    var gridId = _a.gridId, widget = _a.widget, documentActions = _a.documentActions;
    var L = useLanguage().L;
    var wrapperRef = useRef(null);
    var user = useAuth().user;
    var cloneWidget = useCloneWidget();
    var updateWidget = useUpdateWidget();
    var deleteWidget = useDeleteWidget();
    var _b = __read(useState(false), 2), showTagConfiguration = _b[0], setShowTagConfiguration = _b[1];
    var _c = __read(useState(null), 2), draggingOver = _c[0], setDraggingOver = _c[1];
    var _d = __read(useDebounce(draggingOver, 50), 1), draggingOverDebounced = _d[0];
    var widgetConfig = useMemo(function () { return parseWidgetConfig(widget.config, WidgetType.PIVOT); }, [widget.config]);
    function setHideRowColumnHeaders(hideRowColumnHeaders) {
        updateWidget.mutate(__assign(__assign({}, widget), { config: JSON.stringify(__assign(__assign({}, widgetConfig), { hideRowColumnHeaders: hideRowColumnHeaders })) }));
    }
    function setFreezeRowsColumns(freezeRowsColumns) {
        updateWidget.mutate(__assign(__assign({}, widget), { config: JSON.stringify(__assign(__assign({}, widgetConfig), { freezeRowsColumns: freezeRowsColumns })) }));
    }
    function setHideGridlines(hideGridlines) {
        updateWidget.mutate(__assign(__assign({}, widget), { config: JSON.stringify(__assign(__assign({}, widgetConfig), { hideGridlines: hideGridlines })) }));
    }
    function setColumnWidths(columnWidths) {
        updateWidget.mutate(__assign(__assign({}, widget), { config: JSON.stringify(__assign(__assign({}, widgetConfig), { columnWidths: columnWidths })) }));
    }
    function setGlobalFormat(globalFormat) {
        updateWidget.mutate(__assign(__assign({}, widget), { config: JSON.stringify(__assign(__assign({}, widgetConfig), { globalFormat: globalFormat })) }));
    }
    function toggleLabels(labels) {
        updateWidget.mutate(__assign(__assign({}, widget), { config: JSON.stringify(__assign(__assign({}, widgetConfig), { labels: labels })) }));
    }
    function toggleSubtotals(subtotals) {
        updateWidget.mutate(__assign(__assign({}, widget), { config: JSON.stringify(__assign(__assign({}, widgetConfig), { subtotals: subtotals })) }));
    }
    function addEmptyColumn() {
        updateWidget.mutate(__assign(__assign({}, widget), { config: JSON.stringify(__assign(__assign({}, widgetConfig), { columns: __spreadArray(__spreadArray([], __read(widgetConfig.columns), false), [[]], false), variables: __spreadArray([], __read(widgetConfig.variables.map(function (variableRow) { return __spreadArray(__spreadArray([], __read(variableRow), false), [[]], false); })), false) })) }));
    }
    function deleteColumn(index) {
        updateWidget.mutate(__assign(__assign({}, widget), { config: JSON.stringify(__assign(__assign({}, widgetConfig), { columns: widgetConfig.columns.filter(function (c, idx) { return idx !== index; }), variables: __spreadArray([], __read(widgetConfig.variables.map(function (variableRow) { return variableRow.filter(function (c, idx) { return idx !== index; }); })), false) })) }));
    }
    function addEmptyRow() {
        updateWidget.mutate(__assign(__assign({}, widget), { config: JSON.stringify(__assign(__assign({}, widgetConfig), { rows: __spreadArray(__spreadArray([], __read(widgetConfig.rows), false), [[]], false), variables: __spreadArray(__spreadArray([], __read(widgetConfig.variables), false), [widgetConfig.columns.map(function () { return []; })], false) })) }));
    }
    function deleteRow(index) {
        updateWidget.mutate(__assign(__assign({}, widget), { config: JSON.stringify(__assign(__assign({}, widgetConfig), { rows: widgetConfig.rows.filter(function (r, idx) { return idx !== index; }), variables: widgetConfig.variables.filter(function (r, idx) { return idx !== index; }) })) }));
    }
    function removeTag(zoneData, tagIdToRemove) {
        var widgetConfigCopy = __assign({}, widgetConfig);
        if (zoneData.zoneType === PivotZone.Filter) {
            widgetConfigCopy.filters = widgetConfigCopy.filters.filter(function (tagId) { return tagId !== tagIdToRemove; });
        }
        else if (zoneData.zoneType === PivotZone.Column) {
            widgetConfigCopy.columns[zoneData.columnIndex] = widgetConfigCopy.columns[zoneData.columnIndex].filter(function (tagId) { return tagId !== tagIdToRemove; });
        }
        else if (zoneData.zoneType === PivotZone.Row) {
            widgetConfigCopy.rows[zoneData.rowIndex] = widgetConfigCopy.rows[zoneData.rowIndex].filter(function (tagId) { return tagId !== tagIdToRemove; });
        }
        else if (zoneData.zoneType === PivotZone.Variable) {
            widgetConfigCopy.variables[zoneData.rowIndex][zoneData.columnIndex] = widgetConfigCopy.variables[zoneData.rowIndex][zoneData.columnIndex].filter(function (tagId) { return tagId !== tagIdToRemove; });
        }
        updateWidget.mutate(__assign(__assign({}, widget), { config: JSON.stringify(widgetConfigCopy) }));
    }
    var widgetMenuItems = [
        {
            icon: Edit,
            actionName: showTagConfiguration ? L('Show Value') : L('Show Variables and Dimensions'),
            isDisabled: !(documentActions === null || documentActions === void 0 ? void 0 : documentActions.canUpdate),
            action: function () {
                setShowTagConfiguration(!showTagConfiguration);
            },
        },
        { spacer: true },
        {
            isDisabled: !(user === null || user === void 0 ? void 0 : user.classActions.documentClassActions.canUpdate),
            Component: function (props) { return (React.createElement(ThreeStateCheckBox, __assign({}, props, { value: widgetConfig.freezeRowsColumns, action: function () { return setFreezeRowsColumns(!widgetConfig.freezeRowsColumns); }, label: L('Freeze Rows/Columns'), css: { width: '100%', paddingLeft: 10 }, labelStyle: { paddingLeft: 8, fontSize: 12 } }))); },
        },
        {
            isDisabled: !(user === null || user === void 0 ? void 0 : user.classActions.documentClassActions.canUpdate),
            Component: function (props) { return (React.createElement(ThreeStateCheckBox, __assign({}, props, { value: widgetConfig.hideGridlines, action: function () { return setHideGridlines(!widgetConfig.hideGridlines); }, label: L('Hide Gridlines'), css: { width: '100%', paddingLeft: 10 }, labelStyle: { paddingLeft: 8, fontSize: 12 } }))); },
        },
        {
            isDisabled: !(user === null || user === void 0 ? void 0 : user.classActions.documentClassActions.canUpdate),
            Component: function (props) { return (React.createElement(ThreeStateCheckBox, __assign({}, props, { value: widgetConfig.hideRowColumnHeaders, action: function () { return setHideRowColumnHeaders(!widgetConfig.hideRowColumnHeaders); }, label: L('Hide Row/Column Headers'), css: { width: '100%', paddingLeft: 10 }, labelStyle: { paddingLeft: 8, fontSize: 12 } }))); },
        },
        { spacer: true },
        {
            icon: NumberIcon,
            actionName: L('Format'),
            isDisabled: !(user === null || user === void 0 ? void 0 : user.classActions.documentClassActions.canUpdate),
            items: Object.entries(NumberFormatType).map(function (_a) {
                var _b = __read(_a, 2), key = _b[0], value = _b[1];
                return ({
                    isDisabled: !(user === null || user === void 0 ? void 0 : user.classActions.documentClassActions.canUpdate),
                    Component: function (props) { return (React.createElement(ThreeStateCheckBox, __assign({}, props, { value: widgetConfig.globalFormat === value, action: function () { return setGlobalFormat(value); }, label: L(numberFormatTypesMeta[value].label), css: { width: '100%', paddingLeft: 10 }, labelStyle: { paddingLeft: 18, fontSize: 12 } }))); },
                });
            }),
        },
        {
            icon: Labels,
            actionName: L('Labels'),
            isDisabled: !(user === null || user === void 0 ? void 0 : user.classActions.documentClassActions.canUpdate),
            items: [
                {
                    isDisabled: !(user === null || user === void 0 ? void 0 : user.classActions.documentClassActions.canUpdate),
                    Component: function (props) { return (React.createElement(ThreeStateCheckBox, __assign({}, props, { value: widgetConfig.labels === LabelOptions.NAME_DESCRIPTION, action: function () { return toggleLabels(LabelOptions.NAME_DESCRIPTION); }, label: L('Name and Description'), css: { width: '100%', paddingLeft: 10 }, labelStyle: { paddingLeft: 18, fontSize: 12 } }))); },
                },
                {
                    isDisabled: !(user === null || user === void 0 ? void 0 : user.classActions.documentClassActions.canUpdate),
                    Component: function (props) { return (React.createElement(ThreeStateCheckBox, __assign({}, props, { value: widgetConfig.labels === LabelOptions.NAME, action: function () { return toggleLabels(LabelOptions.NAME); }, label: L('Name'), css: { width: '100%', paddingLeft: 10 }, labelStyle: { paddingLeft: 18, fontSize: 12 } }))); },
                },
                {
                    isDisabled: !(user === null || user === void 0 ? void 0 : user.classActions.documentClassActions.canUpdate),
                    Component: function (props) { return (React.createElement(ThreeStateCheckBox, __assign({}, props, { value: widgetConfig.labels === LabelOptions.DESCRIPTION, action: function () { return toggleLabels(LabelOptions.DESCRIPTION); }, label: L('Description'), css: { width: '100%', paddingLeft: 10 }, labelStyle: { paddingLeft: 18, fontSize: 12 } }))); },
                },
            ],
        },
        {
            icon: Sum,
            actionName: L('Subtotals'),
            isDisabled: !(user === null || user === void 0 ? void 0 : user.classActions.documentClassActions.canUpdate),
            items: [
                {
                    isDisabled: !(user === null || user === void 0 ? void 0 : user.classActions.documentClassActions.canUpdate),
                    Component: function (props) { return (React.createElement(ThreeStateCheckBox, __assign({}, props, { value: widgetConfig.subtotals === SubtotalsOptions.DISABLED, action: function () { return toggleSubtotals(SubtotalsOptions.DISABLED); }, label: L('Disabled'), css: { width: '100%', paddingLeft: 10 }, labelStyle: { paddingLeft: 18, fontSize: 12 } }))); },
                },
                {
                    isDisabled: !(user === null || user === void 0 ? void 0 : user.classActions.documentClassActions.canUpdate),
                    Component: function (props) { return (React.createElement(ThreeStateCheckBox, __assign({}, props, { value: widgetConfig.subtotals === SubtotalsOptions.BEFORE, action: function () { return toggleSubtotals(SubtotalsOptions.BEFORE); }, label: L('Before'), css: { width: '100%', paddingLeft: 10 }, labelStyle: { paddingLeft: 18, fontSize: 12 } }))); },
                },
                {
                    isDisabled: !(user === null || user === void 0 ? void 0 : user.classActions.documentClassActions.canUpdate),
                    Component: function (props) { return (React.createElement(ThreeStateCheckBox, __assign({}, props, { value: widgetConfig.subtotals === SubtotalsOptions.AFTER, action: function () { return toggleSubtotals(SubtotalsOptions.AFTER); }, label: L('After'), css: { width: '100%', paddingLeft: 10 }, labelStyle: { paddingLeft: 18, fontSize: 12 } }))); },
                },
            ],
        },
        { spacer: true },
        {
            icon: Copy,
            actionName: L('Duplicate'),
            isDisabled: !(user === null || user === void 0 ? void 0 : user.classActions.documentClassActions.canDuplicate),
            action: function () { return cloneWidget.mutate(widget); },
        },
        {
            icon: Select,
            actionName: L('Move to'),
            isDisabled: !(documentActions === null || documentActions === void 0 ? void 0 : documentActions.canUpdate),
            action: function () { return Manager.renderModal(React.createElement(WidgetParentChangeModal, { widget: widget, gridId: gridId })); },
        },
        { spacer: true },
        {
            icon: Delete,
            actionName: L('Delete Tile'),
            isDisabled: !(documentActions === null || documentActions === void 0 ? void 0 : documentActions.canDelete),
            action: function () { return deleteWidget.mutate(widget.id); },
            destructive: true,
        },
    ];
    return (React.createElement(React.Fragment, null,
        React.createElement(WidgetBox, { ref: wrapperRef },
            widget.title && widget.title !== '' && React.createElement(WidgetTitle, null, widget.title),
            React.createElement(WidgetMenu, { menuItems: widgetMenuItems, wrapperRef: wrapperRef }),
            React.createElement(WidgetContent, { "$overflow": 'hidden' },
                React.createElement(DataEditorZoneGrid, { widgetId: widget.id, widgetConfig: widgetConfig, showTagConfiguration: showTagConfiguration, draggingOver: draggingOver, setDraggingOver: setDraggingOver, draggingOverDebounced: draggingOverDebounced, deleteColumn: deleteColumn, deleteRow: deleteRow, removeTag: removeTag }),
                showTagConfiguration && draggingOverDebounced === null && (React.createElement(React.Fragment, null,
                    React.createElement(PivotAddButton, { "$place": "right" },
                        React.createElement(FSButton, { icon: FaPlus, "$size": "small", "$type": "secondary", "$color": "primary", onClick: addEmptyColumn })),
                    React.createElement(PivotAddButton, { "$place": "bottom" },
                        React.createElement(FSButton, { icon: FaPlus, "$size": "small", "$type": "secondary", "$color": "primary", onClick: addEmptyRow })))),
                React.createElement("div", { style: {
                        visibility: !showTagConfiguration && draggingOverDebounced === null ? 'visible' : 'hidden',
                        height: '100%',
                        width: '100%',
                        position: 'relative',
                        padding: '1px',
                    }, onMouseDown: function (e) { return e.stopPropagation(); } },
                    React.createElement(DataEditorSheet, { widgetConfig: widgetConfig, setColumnWidths: setColumnWidths })))),
        React.createElement(WidgetLoader, { wId: widget.id })));
}
function createDimensionTagIdsArray(tagData, tagIds, filterTagIds, subtotals) {
    var e_1, _a, e_2, _b, e_3, _c;
    var result = [];
    var tagId = tagIds[0];
    if (tagId === undefined) {
        return result;
    }
    var tag = tagData.tagById[tagId];
    if (!tag) {
        return result;
    }
    if (tag.type === TagType.Table) {
        var builder = new TagProgramBuilder();
        builder.addSetTable(tagId).addLogicalTagOp(filterTagIds, Opcode.AND, Opcode.AND);
        var tagIdsArray = evaluateTagProgram(tagData, builder.build());
        if (tagIdsArray.size > 1 && subtotals === SubtotalsOptions.BEFORE) {
            result.push([]);
        }
        try {
            for (var tagIdsArray_1 = __values(tagIdsArray), tagIdsArray_1_1 = tagIdsArray_1.next(); !tagIdsArray_1_1.done; tagIdsArray_1_1 = tagIdsArray_1.next()) {
                var id = tagIdsArray_1_1.value;
                var arr = createDimensionTagIdsArray(tagData, tagIds.slice(1), __spreadArray(__spreadArray([], __read(filterTagIds), false), [id], false), subtotals);
                if (arr.length === 0) {
                    result.push([id]);
                }
                else {
                    try {
                        for (var arr_1 = (e_2 = void 0, __values(arr)), arr_1_1 = arr_1.next(); !arr_1_1.done; arr_1_1 = arr_1.next()) {
                            var row = arr_1_1.value;
                            result.push(__spreadArray([id], __read(row), false));
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (arr_1_1 && !arr_1_1.done && (_b = arr_1.return)) _b.call(arr_1);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (tagIdsArray_1_1 && !tagIdsArray_1_1.done && (_a = tagIdsArray_1.return)) _a.call(tagIdsArray_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        if (tagIdsArray.size > 1 && subtotals === SubtotalsOptions.AFTER) {
            result.push([]);
        }
    }
    else if (tag.type === TagType.Dimension) {
        var arr = createDimensionTagIdsArray(tagData, tagIds.slice(1), __spreadArray(__spreadArray([], __read(filterTagIds), false), [tag.id], false), subtotals);
        if (arr.length === 0) {
            result.push([tag.id]);
        }
        else {
            try {
                for (var arr_2 = __values(arr), arr_2_1 = arr_2.next(); !arr_2_1.done; arr_2_1 = arr_2.next()) {
                    var row = arr_2_1.value;
                    result.push(__spreadArray([tag.id], __read(row), false));
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (arr_2_1 && !arr_2_1.done && (_c = arr_2.return)) _c.call(arr_2);
                }
                finally { if (e_3) throw e_3.error; }
            }
        }
    }
    return result;
}
function createRowsOrCols(tagData, tagIds, filterTagIds, subtotals, labelOptions) {
    var e_4, _a, e_5, _b;
    var headers = [];
    var result = createDimensionTagIdsArray(tagData, tagIds, filterTagIds, subtotals);
    var max = result.length > 0 ? result[0].length : 0;
    try {
        for (var result_1 = __values(result), result_1_1 = result_1.next(); !result_1_1.done; result_1_1 = result_1.next()) {
            var item = result_1_1.value;
            if (item.length > max) {
                max = item.length;
            }
        }
    }
    catch (e_4_1) { e_4 = { error: e_4_1 }; }
    finally {
        try {
            if (result_1_1 && !result_1_1.done && (_a = result_1.return)) _a.call(result_1);
        }
        finally { if (e_4) throw e_4.error; }
    }
    var getLabel = function (tag) {
        return getTagLongName(tag);
    };
    if (labelOptions === LabelOptions.NAME) {
        getLabel = function (tag) { return getTagDisplayName(tag); };
    }
    else if (labelOptions === LabelOptions.DESCRIPTION) {
        getLabel = function (tag) { return tag.description || ''; };
    }
    try {
        for (var result_2 = __values(result), result_2_1 = result_2.next(); !result_2_1.done; result_2_1 = result_2.next()) {
            var item = result_2_1.value;
            var headerLine = [];
            var type = RowColType.NORMAL;
            for (var i = 0; i < max; i++) {
                var tag = tagData.tagById[item[i]];
                if (tag) {
                    headerLine.push(getLabel(tag));
                }
                else {
                    if (headerLine[i - 1] !== 'Total') {
                        headerLine.push('Total');
                        type = RowColType.TOTAL;
                    }
                }
            }
            headers.push({ titles: headerLine, type: type });
        }
    }
    catch (e_5_1) { e_5 = { error: e_5_1 }; }
    finally {
        try {
            if (result_2_1 && !result_2_1.done && (_b = result_2.return)) _b.call(result_2);
        }
        finally { if (e_5) throw e_5.error; }
    }
    return {
        ids: result,
        headers: headers,
    };
}
var CellActionTypes;
(function (CellActionTypes) {
    CellActionTypes["EXPAND_COLLAPSE"] = "EXPAND_COLLAPSE";
})(CellActionTypes || (CellActionTypes = {}));
var GridCell = /** @class */ (function () {
    function GridCell(value, readonly, action) {
        this.value = value;
        this.readonly = readonly;
        this.action = action;
        this.loading = false;
    }
    GridCell.prototype.getDisplayValue = function (globalFormat, languageContext) {
        return '' + this.value;
    };
    GridCell.prototype.getEditValue = function (languageContext) {
        return '' + this.value;
    };
    GridCell.prototype.unformat = function (val, languageContext) {
        return null;
    };
    GridCell.prototype.getStyle = function () {
        var style = {};
        style.fontFamily = 'Inter';
        style.fontSize = 12;
        return style;
    };
    GridCell.prototype.isReadOnly = function () {
        return this.readonly;
    };
    return GridCell;
}());
var HeaderGridCell = /** @class */ (function (_super) {
    __extends(HeaderGridCell, _super);
    function HeaderGridCell(value, readonly, bold, centerText, action) {
        var _this = _super.call(this, value, readonly, action) || this;
        _this.bold = bold;
        _this.centerText = centerText;
        return _this;
    }
    HeaderGridCell.prototype.getStyle = function () {
        var style = {};
        style.fontFamily = 'Inter';
        style.fontSize = 12;
        if (this.centerText) {
            style.textAlign = 'center';
        }
        if (this.bold) {
            style.weight = 'bold';
        }
        return style;
    };
    HeaderGridCell.prototype.getDisplayValue = function (globalFormat, languageContext) {
        return '' + this.value;
    };
    return HeaderGridCell;
}(GridCell));
var NumericalGridCell = /** @class */ (function (_super) {
    __extends(NumericalGridCell, _super);
    function NumericalGridCell(cell, format) {
        var _this = _super.call(this, cell.value, cell.readonly) || this;
        _this.tagIds = cell.tagIds;
        _this.id = cell.id;
        _this.status = cell.status;
        _this.format = format;
        _this.isExcelDateFormat = isExcelDateFormat(_this.format);
        return _this;
    }
    NumericalGridCell.prototype.getDisplayValue = function (globalFormat, languageContext) {
        var prefix = "".concat(this.loading ? '◌  ' : '');
        if (this.value === null || typeof this.value === 'string') {
            return prefix;
        }
        if (this.isExcelDateFormat) {
            return prefix + languageContext.excelLocalizedDateFormat(this.value, this.format);
        }
        else {
            if (this.format === '') {
                return prefix + formatNumber(this.value, globalFormat);
            }
            else {
                return prefix + languageContext.excelLocalizedNumberFormat(this.value, this.format);
            }
        }
    };
    NumericalGridCell.prototype.getEditValue = function (languageContext) {
        if (this.value === null || typeof this.value === 'string') {
            return '';
        }
        if (this.isExcelDateFormat) {
            var date = serialToDate(this.value);
            if (date === null) {
                return '';
            }
            return languageContext.formatLocaleDate(date);
        }
        else {
            return numbro(this.value).format();
        }
    };
    NumericalGridCell.prototype.unformat = function (val, languageContext) {
        if (val === null) {
            return null;
        }
        if (typeof val === 'number') {
            return val;
        }
        if (this.isExcelDateFormat) {
            var date = languageContext.parseLocaleDate(val);
            if (date !== null) {
                return dateToSerial(date);
            }
            else {
                return null;
            }
        }
        else {
            var newValue = numbro.unformat(val);
            if (newValue === undefined || Number.isNaN(newValue)) {
                try {
                    var evald = eval(val);
                    if (typeof evald === 'number' && !isNaN(evald)) {
                        return evald;
                    }
                    else {
                        return null;
                    }
                }
                catch (e) {
                    return null;
                }
            }
            else {
                return newValue;
            }
        }
    };
    NumericalGridCell.prototype.getStyle = function () {
        var style = {};
        style.fontFamily = 'Inter';
        style.fontSize = 12;
        style.textAlign = 'right';
        var readOnlyColor = appColors.ui.dark + '08';
        if (this.readonly) {
            style.fillColor = readOnlyColor;
        }
        if (this.status === CellStatus.CALCULATED ||
            this.status === CellStatus.TOPDOWNED ||
            this.status === CellStatus.AGGREGATED) {
            style.color = appColors.primary.w500;
        }
        if (this.status === CellStatus.TOPDOWN) {
            style.weight = '600';
        }
        return style;
    };
    return NumericalGridCell;
}(GridCell));
var RowColType;
(function (RowColType) {
    RowColType["NORMAL"] = "normal";
    RowColType["TOTAL"] = "total";
})(RowColType || (RowColType = {}));
function createGrid(widgetConfig, tagData, cellAction) {
    var _a, _b, _c, _d, _e, _f;
    return __awaiter(this, void 0, Promise, function () {
        var newCells, rows, cols, subgrids, rowId, colId, variable, rowId, row, _g, ids, headers, row_1, _h, _j, subgrid, i, row_2, _k, _l, subgrid, colId, col, _m, ids, headers, col_1, subgrids_1, subgrids_1_1, subgridRow, i, col_2, subgrids_2, subgrids_2_1, subgridRow, longestRowHeader, i, longestColHeader, i, rows_1, rows_1_1, row, r, c, header, subtotal, r, c, header, subtotal, subgrids_3, subgrids_3_1, subgridRow, subgridRow_1, subgridRow_1_1, subgrid, rowExpressions, colExpressions, _o, _p, row, _q, _r, col, res, startingRowId, startingColId, rowIdx, colIdx, c, accTag, format, variable, colIdx, variableName, col, subtotal, e_6_1, e_7_1;
        var e_8, _s, e_9, _t, e_10, _u, e_11, _v, e_12, _w, e_7, _x, e_6, _y, e_13, _z, e_14, _0;
        return __generator(this, function (_1) {
            switch (_1.label) {
                case 0:
                    newCells = [];
                    rows = [];
                    cols = [];
                    subgrids = [];
                    // create subgrids
                    for (rowId = 0; rowId < widgetConfig.rows.length; rowId++) {
                        subgrids.push([]);
                        for (colId = 0; colId < widgetConfig.columns.length; colId++) {
                            variable = widgetConfig.variables[rowId][colId];
                            subgrids[rowId].push({
                                rows: [],
                                cols: [],
                                variableId: variable[0],
                            });
                        }
                    }
                    // create row definitions
                    for (rowId = 0; rowId < widgetConfig.rows.length; rowId++) {
                        row = widgetConfig.rows[rowId];
                        _g = createRowsOrCols(tagData, row, widgetConfig.filters, widgetConfig.subtotals, widgetConfig.labels), ids = _g.ids, headers = _g.headers;
                        // add empty row so we have the place for variable name
                        rows.push({
                            headers: [],
                            tagIds: [],
                            type: RowColType.NORMAL,
                        });
                        if (headers.length === 0) {
                            row_1 = {
                                headers: [],
                                tagIds: __spreadArray([], __read(widgetConfig.filters), false),
                                type: RowColType.NORMAL,
                            };
                            rows.push(row_1);
                            try {
                                for (_h = (e_8 = void 0, __values(subgrids[rowId])), _j = _h.next(); !_j.done; _j = _h.next()) {
                                    subgrid = _j.value;
                                    subgrid.rows.push(row_1);
                                }
                            }
                            catch (e_8_1) { e_8 = { error: e_8_1 }; }
                            finally {
                                try {
                                    if (_j && !_j.done && (_s = _h.return)) _s.call(_h);
                                }
                                finally { if (e_8) throw e_8.error; }
                            }
                        }
                        for (i = 0; i < headers.length; i++) {
                            row_2 = {
                                headers: headers[i].titles,
                                tagIds: __spreadArray(__spreadArray([], __read(ids[i]), false), __read(widgetConfig.filters), false),
                                type: headers[i].type,
                            };
                            rows.push(row_2);
                            try {
                                for (_k = (e_9 = void 0, __values(subgrids[rowId])), _l = _k.next(); !_l.done; _l = _k.next()) {
                                    subgrid = _l.value;
                                    subgrid.rows.push(row_2);
                                }
                            }
                            catch (e_9_1) { e_9 = { error: e_9_1 }; }
                            finally {
                                try {
                                    if (_l && !_l.done && (_t = _k.return)) _t.call(_k);
                                }
                                finally { if (e_9) throw e_9.error; }
                            }
                        }
                    }
                    // create column definitions
                    for (colId = 0; colId < widgetConfig.columns.length; colId++) {
                        col = widgetConfig.columns[colId];
                        _m = createRowsOrCols(tagData, col, widgetConfig.filters, widgetConfig.subtotals, widgetConfig.labels), ids = _m.ids, headers = _m.headers;
                        if (headers.length === 0) {
                            col_1 = {
                                headers: [],
                                tagIds: [],
                                type: RowColType.NORMAL,
                            };
                            cols.push(col_1);
                            try {
                                for (subgrids_1 = (e_10 = void 0, __values(subgrids)), subgrids_1_1 = subgrids_1.next(); !subgrids_1_1.done; subgrids_1_1 = subgrids_1.next()) {
                                    subgridRow = subgrids_1_1.value;
                                    subgridRow[colId].cols.push(col_1);
                                }
                            }
                            catch (e_10_1) { e_10 = { error: e_10_1 }; }
                            finally {
                                try {
                                    if (subgrids_1_1 && !subgrids_1_1.done && (_u = subgrids_1.return)) _u.call(subgrids_1);
                                }
                                finally { if (e_10) throw e_10.error; }
                            }
                        }
                        for (i = 0; i < headers.length; i++) {
                            col_2 = {
                                headers: headers[i].titles,
                                tagIds: ids[i],
                                type: headers[i].type,
                            };
                            cols.push(col_2);
                            try {
                                for (subgrids_2 = (e_11 = void 0, __values(subgrids)), subgrids_2_1 = subgrids_2.next(); !subgrids_2_1.done; subgrids_2_1 = subgrids_2.next()) {
                                    subgridRow = subgrids_2_1.value;
                                    subgridRow[colId].cols.push(col_2);
                                }
                            }
                            catch (e_11_1) { e_11 = { error: e_11_1 }; }
                            finally {
                                try {
                                    if (subgrids_2_1 && !subgrids_2_1.done && (_v = subgrids_2.return)) _v.call(subgrids_2);
                                }
                                finally { if (e_11) throw e_11.error; }
                            }
                        }
                    }
                    longestRowHeader = rows.reduce(function (max, item) { return Math.max(item.headers.length, max); }, 0);
                    for (i = 0; i < longestRowHeader; i++) {
                        cols.unshift({
                            headers: [],
                            tagIds: [],
                            type: RowColType.NORMAL,
                        });
                    }
                    longestColHeader = cols.reduce(function (max, item) { return Math.max(item.headers.length, max); }, 0);
                    for (i = 0; i < longestColHeader; i++) {
                        rows.unshift({
                            headers: [],
                            tagIds: [],
                            type: RowColType.NORMAL,
                        });
                    }
                    try {
                        // prefill newCells rows
                        for (rows_1 = __values(rows), rows_1_1 = rows_1.next(); !rows_1_1.done; rows_1_1 = rows_1.next()) {
                            row = rows_1_1.value;
                            newCells.push([]);
                        }
                    }
                    catch (e_12_1) { e_12 = { error: e_12_1 }; }
                    finally {
                        try {
                            if (rows_1_1 && !rows_1_1.done && (_w = rows_1.return)) _w.call(rows_1);
                        }
                        finally { if (e_12) throw e_12.error; }
                    }
                    // create column header cells
                    for (r = 0; r < longestColHeader; r++) {
                        for (c = 0; c < cols.length; c++) {
                            header = ((_b = (_a = cols === null || cols === void 0 ? void 0 : cols[c]) === null || _a === void 0 ? void 0 : _a.headers) === null || _b === void 0 ? void 0 : _b[r]) || '';
                            subtotal = ((_c = cols === null || cols === void 0 ? void 0 : cols[c]) === null || _c === void 0 ? void 0 : _c.type) === RowColType.TOTAL;
                            newCells[r][c] = new HeaderGridCell(header, true, subtotal, true, cellAction);
                        }
                    }
                    // create row header cells
                    for (r = 0; r < rows.length; r++) {
                        for (c = 0; c < longestRowHeader; c++) {
                            header = ((_e = (_d = rows === null || rows === void 0 ? void 0 : rows[r]) === null || _d === void 0 ? void 0 : _d.headers) === null || _e === void 0 ? void 0 : _e[c]) || '';
                            subtotal = ((_f = rows === null || rows === void 0 ? void 0 : rows[r]) === null || _f === void 0 ? void 0 : _f.type) === RowColType.TOTAL;
                            newCells[r][c] = new HeaderGridCell(header, true, subtotal, false, cellAction);
                        }
                    }
                    _1.label = 1;
                case 1:
                    _1.trys.push([1, 12, 13, 14]);
                    subgrids_3 = __values(subgrids), subgrids_3_1 = subgrids_3.next();
                    _1.label = 2;
                case 2:
                    if (!!subgrids_3_1.done) return [3 /*break*/, 11];
                    subgridRow = subgrids_3_1.value;
                    _1.label = 3;
                case 3:
                    _1.trys.push([3, 8, 9, 10]);
                    subgridRow_1 = (e_6 = void 0, __values(subgridRow)), subgridRow_1_1 = subgridRow_1.next();
                    _1.label = 4;
                case 4:
                    if (!!subgridRow_1_1.done) return [3 /*break*/, 7];
                    subgrid = subgridRow_1_1.value;
                    rowExpressions = [];
                    colExpressions = [];
                    try {
                        for (_o = (e_13 = void 0, __values(subgrid.rows)), _p = _o.next(); !_p.done; _p = _o.next()) {
                            row = _p.value;
                            rowExpressions.push("tags(".concat(row.tagIds.join(','), ")"));
                        }
                    }
                    catch (e_13_1) { e_13 = { error: e_13_1 }; }
                    finally {
                        try {
                            if (_p && !_p.done && (_z = _o.return)) _z.call(_o);
                        }
                        finally { if (e_13) throw e_13.error; }
                    }
                    try {
                        for (_q = (e_14 = void 0, __values(subgrid.cols)), _r = _q.next(); !_r.done; _r = _q.next()) {
                            col = _r.value;
                            colExpressions.push("tags(".concat(__spreadArray(__spreadArray([], __read(col.tagIds), false), [subgrid.variableId], false).join(','), ")"));
                        }
                    }
                    catch (e_14_1) { e_14 = { error: e_14_1 }; }
                    finally {
                        try {
                            if (_r && !_r.done && (_0 = _q.return)) _0.call(_q);
                        }
                        finally { if (e_14) throw e_14.error; }
                    }
                    if (rowExpressions.length === 1 &&
                        rowExpressions[0] === 'tags()' &&
                        colExpressions.length === 1 &&
                        colExpressions[0] === 'tags()') {
                        return [3 /*break*/, 6];
                    }
                    return [4 /*yield*/, evaluatorApi.evaluate({
                            rows: rowExpressions,
                            cols: colExpressions,
                        })];
                case 5:
                    res = _1.sent();
                    startingRowId = rows.indexOf(subgrid.rows[0]);
                    startingColId = cols.indexOf(subgrid.cols[0]);
                    for (rowIdx = 0; rowIdx < rowExpressions.length; rowIdx++) {
                        for (colIdx = 0; colIdx < colExpressions.length; colIdx++) {
                            c = res[rowIdx][colIdx];
                            accTag = tagData.tagById[c.tagIds[c.tagIds.length - 1]];
                            format = accTag && accTag.numberFormat ? accTag.numberFormat.format : '';
                            newCells[rowIdx + startingRowId][colIdx + startingColId] = new NumericalGridCell(c, format);
                        }
                    }
                    variable = tagData.tagById[subgrid.variableId];
                    for (colIdx = 0; colIdx < colExpressions.length; colIdx++) {
                        variableName = variable ? getTagDisplayName(variable) : '';
                        col = cols[colIdx + startingColId];
                        subtotal = col && col.type === RowColType.TOTAL;
                        newCells[startingRowId - 1][colIdx + startingColId] = new HeaderGridCell(variableName, true, subtotal, true, cellAction);
                    }
                    _1.label = 6;
                case 6:
                    subgridRow_1_1 = subgridRow_1.next();
                    return [3 /*break*/, 4];
                case 7: return [3 /*break*/, 10];
                case 8:
                    e_6_1 = _1.sent();
                    e_6 = { error: e_6_1 };
                    return [3 /*break*/, 10];
                case 9:
                    try {
                        if (subgridRow_1_1 && !subgridRow_1_1.done && (_y = subgridRow_1.return)) _y.call(subgridRow_1);
                    }
                    finally { if (e_6) throw e_6.error; }
                    return [7 /*endfinally*/];
                case 10:
                    subgrids_3_1 = subgrids_3.next();
                    return [3 /*break*/, 2];
                case 11: return [3 /*break*/, 14];
                case 12:
                    e_7_1 = _1.sent();
                    e_7 = { error: e_7_1 };
                    return [3 /*break*/, 14];
                case 13:
                    try {
                        if (subgrids_3_1 && !subgrids_3_1.done && (_x = subgrids_3.return)) _x.call(subgrids_3);
                    }
                    finally { if (e_7) throw e_7.error; }
                    return [7 /*endfinally*/];
                case 14: return [2 /*return*/, [newCells, longestColHeader, longestRowHeader]];
            }
        });
    });
}
function createUpdateCellsRequest(cells, changes, languageContext) {
    var e_15, _a;
    var _b;
    var updates = [];
    var newGrid = __spreadArray([], __read(cells), false);
    try {
        for (var changes_1 = __values(changes), changes_1_1 = changes_1.next(); !changes_1_1.done; changes_1_1 = changes_1.next()) {
            var change = changes_1_1.value;
            var cell = (_b = cells === null || cells === void 0 ? void 0 : cells[change.y]) === null || _b === void 0 ? void 0 : _b[change.x];
            if (!cell) {
                continue;
            }
            var value = change.value;
            var processed = cell.unformat(value, languageContext);
            if (cell instanceof NumericalGridCell) {
                updates.push({
                    id: cell.id,
                    tagIds: cell.tagIds,
                    value: processed,
                });
                cell.value = processed;
                cell.loading = true;
            }
        }
    }
    catch (e_15_1) { e_15 = { error: e_15_1 }; }
    finally {
        try {
            if (changes_1_1 && !changes_1_1.done && (_a = changes_1.return)) _a.call(changes_1);
        }
        finally { if (e_15) throw e_15.error; }
    }
    return [newGrid, updates];
}
function DataEditorSheet(props) {
    var _this = this;
    var tagData = useTagContext().tagData;
    var languageContext = useLanguage();
    var _a = __read(useState(0), 2), invalidate = _a[0], setInvalidate = _a[1];
    var _b = __read(useState([]), 2), cells = _b[0], setCells = _b[1];
    var _c = useTableCells(props.widgetConfig.columnWidths), onCellWidthChange = _c.onCellWidthChange, onCellHeightChange = _c.onCellHeightChange, cellWidth = _c.cellWidth, cellHeight = _c.cellHeight;
    var _d = __read(useDebounce(cellWidth, 1000), 1), debouncedCellWidth = _d[0];
    var _e = __read(useState(0), 2), freezeRows = _e[0], setFreezeRows = _e[1];
    var _f = __read(useState(0), 2), freezeColumns = _f[0], setFreezeColumns = _f[1];
    var _g = __read(useState(true), 2), firstTimeLoading = _g[0], setFirstTimeLoading = _g[1];
    var cellAction = useCallback(function (payload) {
        switch (payload.type) {
            case CellActionTypes.EXPAND_COLLAPSE: {
                break;
            }
            default:
        }
    }, [props.widgetConfig]);
    var displayData = useCallback(function (col, row) {
        var _a;
        var cell = (_a = cells === null || cells === void 0 ? void 0 : cells[row]) === null || _a === void 0 ? void 0 : _a[col];
        if (cell) {
            return cell.getDisplayValue(props.widgetConfig.globalFormat, languageContext);
        }
        return null;
    }, [cells, languageContext, props.widgetConfig.globalFormat]);
    var editData = useCallback(function (col, row) {
        var _a;
        var cell = (_a = cells === null || cells === void 0 ? void 0 : cells[row]) === null || _a === void 0 ? void 0 : _a[col];
        if (cell) {
            return cell.getEditValue(languageContext);
        }
        return '';
    }, [cells, languageContext]);
    var sourceData = useCallback(function (col, row) {
        var _a;
        var cell = (_a = cells === null || cells === void 0 ? void 0 : cells[row]) === null || _a === void 0 ? void 0 : _a[col];
        if (cell) {
            return cell.value;
        }
        return null;
    }, [cells]);
    var onChange = function (changes) { return __awaiter(_this, void 0, void 0, function () {
        var _a, newCells, updates, e_16, errorBody, ee_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = __read(createUpdateCellsRequest(cells, changes, languageContext), 2), newCells = _a[0], updates = _a[1];
                    // optimistically update cells
                    setCells(newCells);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 8]);
                    return [4 /*yield*/, cellsApi.updateBatch(updates)];
                case 2:
                    _b.sent();
                    return [3 /*break*/, 8];
                case 3:
                    e_16 = _b.sent();
                    _b.label = 4;
                case 4:
                    _b.trys.push([4, 6, , 7]);
                    return [4 /*yield*/, e_16.json()];
                case 5:
                    errorBody = _b.sent();
                    toast.error('Error updating cells. ' + errorBody.message);
                    return [3 /*break*/, 7];
                case 6:
                    ee_1 = _b.sent();
                    toast.error('Error updating cells.');
                    return [3 /*break*/, 7];
                case 7: return [3 /*break*/, 8];
                case 8:
                    // reevaluate the grid
                    setInvalidate(function (old) { return old + 1; });
                    return [2 /*return*/];
            }
        });
    }); };
    var cellStyle = function (col, row) {
        var _a;
        var cell = (_a = cells === null || cells === void 0 ? void 0 : cells[row]) === null || _a === void 0 ? void 0 : _a[col];
        if (cell) {
            return cell.getStyle();
        }
        return {};
    };
    var isReadOnly = function (col, row) {
        var _a;
        var cell = (_a = cells === null || cells === void 0 ? void 0 : cells[row]) === null || _a === void 0 ? void 0 : _a[col];
        if (cell) {
            return cell.isReadOnly();
        }
        return true;
    };
    var onColWidthChange = function (columnIdx, newWidth) {
        onCellWidthChange(columnIdx, newWidth);
    };
    useEffect(function () {
        props.setColumnWidths(debouncedCellWidth);
    }, [debouncedCellWidth]);
    useEffect(function () {
        var active = true;
        createGrid(props.widgetConfig, tagData, cellAction).then(function (_a) {
            var _b = __read(_a, 3), grid = _b[0], freezeRows = _b[1], freezeColumns = _b[2];
            if (active) {
                setCells(grid);
                setFreezeColumns(freezeColumns);
                setFreezeRows(freezeRows);
                setFirstTimeLoading(false);
            }
        });
        return function () {
            active = false;
        };
    }, [tagData, props.widgetConfig, invalidate, cellAction]);
    if (firstTimeLoading) {
        return (React.createElement(LoadingWrap, null,
            React.createElement(Loading, { "$size": 2 })));
    }
    return (React.createElement(Sheet, { displayData: displayData, editData: editData, sourceData: sourceData, onChange: onChange, onCellHeightChange: onCellHeightChange, onCellWidthChange: onColWidthChange, cellHeight: cellHeight, cellWidth: cellWidth, cellStyle: cellStyle, readOnly: isReadOnly, sheetStyle: {
            hideGridlines: props.widgetConfig.hideGridlines,
            freezeRows: props.widgetConfig.freezeRowsColumns ? freezeRows : 0,
            freezeColumns: props.widgetConfig.freezeRowsColumns ? freezeColumns : 0,
            hideRowHeaders: props.widgetConfig.hideRowColumnHeaders,
            hideColumnHeaders: props.widgetConfig.hideRowColumnHeaders,
            hideScrollBars: props.widgetConfig.hideRowColumnHeaders,
        } }));
}
function ZoneRemoveButton(_a) {
    var shown = _a.shown, deleteAction = _a.deleteAction;
    if (!shown) {
        return null;
    }
    else {
        return (React.createElement(TagDropzoneButton, null,
            React.createElement(FSButton, { icon: FaTimes, "$type": "tertiary", "$color": "error", "$size": "small", onClick: function (e) {
                    deleteAction();
                    e.stopPropagation();
                } })));
    }
}
function DataEditorZoneGrid(_a) {
    var widgetId = _a.widgetId, widgetConfig = _a.widgetConfig, showTagConfiguration = _a.showTagConfiguration, draggingOver = _a.draggingOver, setDraggingOver = _a.setDraggingOver, draggingOverDebounced = _a.draggingOverDebounced, deleteColumn = _a.deleteColumn, deleteRow = _a.deleteRow, removeTag = _a.removeTag;
    var tagData = useTagContext().tagData;
    var _b = __read(useState(null), 2), selectedColumnRow = _b[0], setSelectedColumnRow = _b[1];
    var zoneArray = [];
    // add filter zone to first place
    zoneArray.push({
        zoneType: PivotZone.Filter,
        tagIds: widgetConfig.filters,
        rowIndex: 0,
        columnIndex: 0,
        onClick: function () { return setSelectedColumnRow(null); },
    });
    var _loop_1 = function (columnIndex) {
        var columnTagIds = widgetConfig.columns[columnIndex];
        zoneArray.push({
            zoneType: PivotZone.Column,
            tagIds: columnTagIds,
            rowIndex: 0,
            columnIndex: columnIndex,
            onClick: function () {
                if ((selectedColumnRow === null || selectedColumnRow === void 0 ? void 0 : selectedColumnRow.columnIndex) === columnIndex) {
                    setSelectedColumnRow(null);
                }
                else {
                    setSelectedColumnRow({ columnIndex: columnIndex });
                }
            },
        });
    };
    // add all column zones next
    for (var columnIndex = 0; columnIndex < widgetConfig.columns.length; columnIndex++) {
        _loop_1(columnIndex);
    }
    var _loop_2 = function (rowIndex) {
        // row zone
        var rowTagIds = widgetConfig.rows[rowIndex];
        zoneArray.push({
            zoneType: PivotZone.Row,
            tagIds: rowTagIds,
            rowIndex: rowIndex,
            columnIndex: 0,
            onClick: function () {
                if ((selectedColumnRow === null || selectedColumnRow === void 0 ? void 0 : selectedColumnRow.rowIndex) === rowIndex) {
                    setSelectedColumnRow(null);
                }
                else {
                    setSelectedColumnRow({ rowIndex: rowIndex });
                }
            },
        });
        var _loop_3 = function (columnIndex) {
            var variableTagIds = widgetConfig.variables[rowIndex][columnIndex];
            if (variableTagIds !== undefined) {
                zoneArray.push({
                    zoneType: PivotZone.Variable,
                    tagIds: variableTagIds,
                    rowIndex: rowIndex,
                    columnIndex: columnIndex,
                    onClick: function () {
                        if ((selectedColumnRow === null || selectedColumnRow === void 0 ? void 0 : selectedColumnRow.columnIndex) === columnIndex) {
                            // column is selected -> select row
                            setSelectedColumnRow({ rowIndex: rowIndex });
                        }
                        else if ((selectedColumnRow === null || selectedColumnRow === void 0 ? void 0 : selectedColumnRow.rowIndex) === rowIndex) {
                            // row is selected -> select column
                            setSelectedColumnRow({ columnIndex: columnIndex });
                        }
                        else if ((selectedColumnRow === null || selectedColumnRow === void 0 ? void 0 : selectedColumnRow.columnIndex) !== undefined) {
                            // another column is selected -> select this column
                            setSelectedColumnRow({ columnIndex: columnIndex });
                        }
                        else if ((selectedColumnRow === null || selectedColumnRow === void 0 ? void 0 : selectedColumnRow.rowIndex) !== undefined) {
                            // another row is selected -> select this row
                            setSelectedColumnRow({ rowIndex: rowIndex });
                        }
                        else {
                            // nothing is selected -> select this column
                            setSelectedColumnRow({ columnIndex: columnIndex });
                        }
                    },
                });
            }
        };
        // variable zones
        for (var columnIndex = 0; columnIndex < widgetConfig.columns.length; columnIndex++) {
            _loop_3(columnIndex);
        }
    };
    // add all row zones with as many variable zones as there are columns
    for (var rowIndex = 0; rowIndex < widgetConfig.rows.length; rowIndex++) {
        _loop_2(rowIndex);
    }
    return (React.createElement(TagDropzoneGrid, { "$visible": showTagConfiguration || draggingOverDebounced !== null, "$rowNumber": widgetConfig.rows.length + 1, "$columnNumber": widgetConfig.columns.length + 1 }, zoneArray.map(function (zoneData) {
        var droppableId = createDroppableId({
            type: DroppableType.PivotWidget,
            widgetId: widgetId,
            zone: zoneData.zoneType,
            rowIndex: zoneData.rowIndex,
            columnIndex: zoneData.columnIndex,
        });
        return (React.createElement(Droppable, { droppableId: droppableId, key: droppableId }, function (provided, snapshot) {
            useEffect(function () {
                if ((draggingOver === null ||
                    draggingOver.zoneType !== zoneData.zoneType ||
                    draggingOver.columnIndex !== zoneData.columnIndex ||
                    draggingOver.rowIndex !== zoneData.rowIndex) &&
                    snapshot.isDraggingOver) {
                    // set draggingOver to this zone if not already set
                    setDraggingOver({
                        zoneType: zoneData.zoneType,
                        rowIndex: zoneData.rowIndex,
                        columnIndex: zoneData.columnIndex,
                    });
                }
                else if (draggingOver !== null &&
                    draggingOver.zoneType === zoneData.zoneType &&
                    draggingOver.columnIndex === zoneData.columnIndex &&
                    draggingOver.rowIndex === zoneData.rowIndex &&
                    !snapshot.isDraggingOver) {
                    // set draggingOver to null when leaving this zone
                    setDraggingOver(null);
                }
            }, [draggingOver, setDraggingOver, snapshot, zoneData]);
            var thisRowSelected = (selectedColumnRow === null || selectedColumnRow === void 0 ? void 0 : selectedColumnRow.rowIndex) === zoneData.rowIndex;
            var thisColumnSelected = (selectedColumnRow === null || selectedColumnRow === void 0 ? void 0 : selectedColumnRow.columnIndex) === zoneData.columnIndex;
            var zoneTagObjects = zoneData.tagIds
                .map(function (tagId) { return tagData.tagById[tagId]; })
                .filter(function (tag) { return tag !== undefined; });
            var zoneContent = zoneTagObjects.length > 0 ? (zoneTagObjects.map(function (tag, tagIndex) {
                var draggableId = createDraggableId({
                    type: DraggableType.Tag,
                    tagId: tag.id,
                    tagType: getDraggableTagType(tag.type),
                    sourceDroppableId: droppableId,
                });
                return (React.createElement(Draggable, { key: draggableId, draggableId: draggableId, index: tagIndex }, function (draggableProvided, draggableSnapshot) {
                    var tagComponent = (React.createElement("div", __assign({ ref: draggableProvided.innerRef }, draggableProvided.draggableProps, draggableProvided.dragHandleProps),
                        React.createElement(Tag, { tag: tag, canUpdate: true, onDelete: function (e) {
                                removeTag(zoneData, tag.id);
                                e.stopPropagation();
                            } })));
                    if (draggableSnapshot.isDragging) {
                        return createPortal(tagComponent, document.getElementById('portal'));
                    }
                    else {
                        return tagComponent;
                    }
                }));
            })) : (React.createElement(TagDropzonePlaceholder, null, zoneData.zoneType));
            return (React.createElement(TagDropzone, __assign({ ref: provided.innerRef }, provided.droppableProps, { "$hovered": draggingOverDebounced === null ||
                    (draggingOverDebounced.zoneType === zoneData.zoneType &&
                        draggingOverDebounced.columnIndex === zoneData.columnIndex &&
                        draggingOverDebounced.rowIndex === zoneData.rowIndex), "$selected": (thisRowSelected &&
                    (zoneData.zoneType === PivotZone.Row ||
                        zoneData.zoneType === PivotZone.Variable)) ||
                    (thisColumnSelected &&
                        (zoneData.zoneType === PivotZone.Column ||
                            zoneData.zoneType === PivotZone.Variable)), 
                // only perform onClick if data editor configuration is shown
                onClick: showTagConfiguration ? zoneData.onClick : undefined }),
                zoneContent,
                React.createElement(ZoneRemoveButton, { shown: (thisRowSelected &&
                        zoneData.columnIndex === widgetConfig.columns.length - 1 &&
                        zoneData.zoneType === PivotZone.Variable) ||
                        (thisColumnSelected && zoneData.zoneType === PivotZone.Column), deleteAction: thisColumnSelected
                        ? function () {
                            deleteColumn(zoneData.columnIndex);
                            setSelectedColumnRow(null);
                        }
                        : function () {
                            deleteRow(zoneData.rowIndex);
                            setSelectedColumnRow(null);
                        } })));
        }));
    })));
}
